import { SAModal } from '@saux/design-system-react';
import styled from 'styled-components';

export const Modal = styled(SAModal)`
margin-top: 80px;
overflow: hidden;
background-color:rgba(4,30,65,0.75);
z-index:100;
`;